import { Injectable } from '@angular/core';
import {BehaviorSubject, combineLatestWith, finalize, Observable} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import { ManagementStoreService } from './management-store.service';
import { ManagementApiService } from '@emm/management/services/management-api.service';
import {genericSort} from '@emm/core/util/sort.util';
import {GenericItem} from '@emm/core/models/context-menu-action.model';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {SearchFilter} from '@emm/core/models/search-filter';

@Injectable({
    providedIn: 'root'
})
export class LocationSetTypesFacadeService {

    locationSetTypes$ = this.api.getAllLocationSetTypes();
    locationSetTypeDetail$ = new BehaviorSubject<any>(null);
    updateLocationSetType$ = new BehaviorSubject<any>(null);

    locationSetTypesAsGenericItems$ = this.locationSetTypes$.pipe(
        filter(RA.isNotNil),
        map((locationSetTypes) =>
            locationSetTypes.sort(genericSort(a => a['name']))
                .map(
                (locationSetType) =>
                    ({
                        name: locationSetType.name,
                        tag: locationSetType.tag,
                        disabled: false,
                        source: locationSetType,
                    } as GenericItem<LocationSetType>)
            )
        )
    );

    centerLoading$ = this.managementStore.isLoading$.locationSetTypes;

    rightLoading$ = this.managementStore.isLoading$.base;

    anyLoading$ = this.centerLoading$.pipe(
        combineLatestWith(this.rightLoading$),
        map((sources: boolean[]) => R.any(R.equals(true), sources))
    );

    constructor(
        private managementStore: ManagementStoreService,
        public api: ManagementApiService) {}



    init(): void {
        this.managementStore.dispatch.initLocationSetTypes();
    }



    selectLocationSetType(locationSetType: LocationSetType): void {
        let locationSetDetail;
        this.api.getLocationSetType(locationSetType.tag).subscribe(result => {
            locationSetDetail = result;
            this.locationSetTypeDetail$.next(locationSetDetail[0]);
        });
    }



    searchLocationSetTypes(searchFilter: SearchFilter): void {
        this.managementStore.dispatch.searchLocationSetTypes(searchFilter);
    }



    updateLocationSetType(tag: string, updates: any, dispatchReload: boolean): Observable<boolean> {
        this.api.updateLocationSetType(tag, updates).subscribe();
        this.updateLocationSetType$.next(dispatchReload);
        return this.updateLocationSetType$.pipe(take(1));
    }



    openAddDialog(): void {
        this.managementStore.dispatch.openAddLocationSetTypeDialog();
    }



    deleteLocationSetType(locationSetType: LocationSetType): void {
        this.startProgressBar()
        this.api.deleteLocationSetType(locationSetType.tag)
            .pipe(finalize(() => this.stopProgressBar()))
            .subscribe();
    }


    startProgressBar(): void {
        this.managementStore.dispatch.startLoading();

    }
    stopProgressBar(): void {
        this.managementStore.dispatch.stopLoading();
    }
}
